import {GridMinmax} from '../types/GridMinmax';
import {GridTrackBreadth} from '../types/GridTrackBreadth';
import {getGridTrackSize} from './getGridTrackSize';

/**
 * @about CSS `minmax()` track. Integers are design-system steps.
 * @example gridMinmax(25, '1fr')
 */
export function gridMinmax(
  min: Exclude<GridTrackBreadth, `${number}fr`>,
  max: GridTrackBreadth
): GridMinmax {
  return {minmax: `minmax(${getGridTrackSize(min)}, ${getGridTrackSize(max)})`};
}
